
































  import { Tooltip } from '@/commun/components/champ-formulaire/tooltip';
  import RadioGroup from '@/commun/components/radio-group/radio-group.vue';
  import { EchelleNotation } from '@/components/faculte/demandes/formulaires/champs/echelle-notation/echelle-notation';
  import Vue from 'vue';

  export default Vue.extend({
    name: 'EchelleNotationRadioGroup',
    components: { RadioGroup, Tooltip },
    props: {
      value: {
        type: String,
        default: undefined,
        validator(valeur: string) {
          return (Object.values(EchelleNotation) as string[]).includes(valeur);
        },
      },
      nom: {
        type: String,
        default() {
          return this.$t('demande.formulaires.champs.echelle-notation.nom');
        },
      },
      validation: {
        type: String,
        default: 'requis',
      },
    },
    computed: {
      estEchelleLettree(): boolean {
        return this.value && this.value === EchelleNotation.LETTRE;
      },
      echellesNotation(): EchelleNotation[] {
        return Object.values(EchelleNotation);
      },
    },
  });
